import React from "react";
import { useNavigate } from "react-router-dom";
import {ReactComponent as TruckSvg} from './../assets/icons/svg/truck.svg';
import {ReactComponent as ReceiptSvg} from './../assets/icons/svg/receipt.svg';
import {currencyConverter} from './../utils/index';
import moment from 'moment';

export default function ListNotif({data, type, onClick}) {
   const navigate = useNavigate();

   const formatDate = (date) => {
      let d = new Date(date);
      let day = d.getDate();
      let strArray=['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      let month = strArray[d.getMonth()];
      let year = d.getFullYear();
      let time = d.getHours() + ':' + d.getMinutes();
      return day + ' ' + month + ' ' + year + ' ' + time + ' WIB';


   };

   return (
      <div className="d-flex align-items-center justify-content-between py-3" onClick={onClick}>
         <div className="d-flex align-items-center">
            <div className="item-transaction-icon" style={{width:'50px'}}>
               {type === 'transaction' ? 
                  <ReceiptSvg/> : 
                  <TruckSvg/>
               }
            </div>
         </div>
         <div className="d-flex align-items-center">
            <div className="item-transaction-amount">
               <div className={data?.read_at === null ? 'ts-ssm' : 'ts-ssm'}>
                  {data?.data?.body}
               </div>
               <small className="text-muted ts-sm">{moment(new Date(data?.created_at)).format('DD/MM/YYYY HH:mm') + ' WIB'}</small>
            </div>
            <i className="ph-caret-right ms-3 fw-bold text-dark"></i>
         </div>
      </div>
   );
}